import { CopyMetadataFromParent, Property } from '@skylab-shared/core';
import { SaleAdvanceDocumentModel } from './sale-advance-invoice.model';
import { SaleDocumentKind } from './sale-document-kind';

@CopyMetadataFromParent()
export class SaleAdvanceAdjustmentDocumentModel extends SaleAdvanceDocumentModel {
    @Property()
    public adjustmentReasonId: number;

    @Property()
    public advanceReturnValue: number;

    @Property({ nullable: true })
    public adjustedDocumentId: number;

    @Property()
    public override readonly kind: SaleDocumentKind = SaleDocumentKind.AdvanceInvoiceAdjustment;
}
